/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable default-case */
const { MODULE_ASSET_PREFIX, SCRIPT_TYPE } = require("../../config/constants");
const { SCRIPT, VENDOR } = SCRIPT_TYPE;
const { generateScriptId } = require("./utils");

const generateResource = ({
  type,
  id,
  src,
  onLoad,
  onError,
  testId,
  identifier,
  preload,
}) => {
  const elementTypes = {
    script: "script",
    style: "link",
  };

  if (!Object.keys(elementTypes).includes(type)) {
    /* istanbul ignore next */
    throw new TypeError("Invalid resource type");
  }

  let resource = document.head.querySelector(`#${id}`);

  if (resource) {
    if (resource.getAttribute("data-loaded") === "true") {
      onLoad && onLoad();
    } else {
      resource.addEventListener("load", () => onLoad && onLoad(), {
        once: true,
      });
    }
  } else {
    resource = document.createElement(elementTypes[type]);
    document.head.appendChild(resource);

    resource.id = id;
    resource.setAttribute("data-testid", testId);

    if (identifier) {
      resource.setAttribute("data-identifier", identifier);
    }

    if (preload) {
      resource.setAttribute("data-preloaded", true);
    }

    switch (type) {
      case "script":
        resource.src = `${src}`;

        break;

      case "style":
        resource.rel = "stylesheet";
        resource.type = "text/css";
        resource.href = `${src}`;

        break;
    }

    resource.async = true;
    resource.setAttribute("data-loaded", false);

    resource.onload = () => {
      resource.setAttribute("data-loaded", true);

      if (onLoad) {
        onLoad();
      }
    };

    resource.onerror = (err) => {
      if (onError) {
        resource.remove();
        onError(err);
      }
    };
  }

  return resource;
};

const loadScript = async (data) =>
  new Promise((resolve, reject) => {
    generateResource({
      type: "script",
      onLoad: resolve,
      onError: () => {
        reject("Cannot load required resource.");
      },
      ...data,
    });
  });

const processManifestScripts =
  ({ vendor, name, manifest, errorCallback, identifier, preload }) =>
  async (callback) => {
    if (!manifest[`${MODULE_ASSET_PREFIX}${name}.js`]) {
      console.error(
        `Cannot find required resource: ${MODULE_ASSET_PREFIX}${name}.js`
      );
      errorCallback({ message: "Cannot find required resource." });

      return;
    }

    const mainScriptId = generateScriptId(identifier, SCRIPT);
    const vendorScriptId = generateScriptId(identifier, VENDOR);

    if (vendor && manifest[`${MODULE_ASSET_PREFIX}vendor.js`]) {
      try {
        await loadScript({
          id: vendorScriptId,
          src: manifest[`${MODULE_ASSET_PREFIX}vendor.js`],
          testId: `remote-module-vendor-script`,
          preload,
        });
      } catch (e) {
        console.error(`Error loading vendor: ${e}`);
      }
    }

    try {
      await loadScript({
        id: mainScriptId,
        src: manifest[`${MODULE_ASSET_PREFIX}${name}.js`],
        testId: `remote-module-main-script`,
        preload,
      });
      callback && (await callback());
    } catch (e) {
      console.error(`Error loading script: ${e}`);
      errorCallback({ message: "Error loading script." });
    }
  };

module.exports = {
  generateResource,
  loadScript,
  processManifestScripts,
};
